import { trpc } from './trpc';

/**
 * Hook to check if the current user is a super admin.
 * The check is performed server-side so admin emails are never exposed in the client bundle.
 */
export function useSuperAdmin() {
  const { data, isLoading } = trpc.admin.isSuperAdmin.useQuery();
  return { isSuperAdmin: data?.isSuperAdmin ?? false, isLoading };
}
